import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { TierStore } from './tier.store';
import { mapTo, tap } from 'rxjs/operators';
import { LoyaltyTier } from './models/tier.model';
import { LoyaltyCustomerTier } from './models/customer.tier.model';
import { cacheable } from '@datorama/akita';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({
  providedIn: 'root'
})
export class TierService {

  constructor(private api: ApiService, private tierStore: TierStore, private logService: LoggingService) { }

  fetchTiers(clubId: number){
    const request$ = this.api.get<LoyaltyTier>(`loyalty/tiers/${clubId}`).pipe(
      tap((tiers) => {
        this.logService.debug(`Fetching Tiers`);
        this.tierStore.set(tiers);
      })
    );
    return cacheable(this.tierStore, request$).pipe(mapTo(null));
  }

  fetchTier(clubId: number, portalId: string, purseNumber: number) {
    const request$ = this.api.getAnySingle<LoyaltyCustomerTier>(`loyalty/tiers/${clubId}/${portalId}/${purseNumber}`)
      .pipe(
        tap((tier) => {
          this.logService.debug(`Fetching customer loyalty tier`);
          this.tierStore.setTier(tier);
        })
      );
    return cacheable(this.tierStore, request$).pipe(mapTo(null));
  }

  fetchTiersWithPositions(externalRefNumber: string) {
    const request$ = this.api.getAnySingle<LoyaltyCustomerTier>(`loyalty/tiers/v2/${externalRefNumber}`)
      .pipe(
        tap((tier) => {
          this.logService.debug(`Fetching customer loyalty tiers with positions`);
          this.tierStore.setTier(tier);
        })
      );
    return cacheable(this.tierStore, request$).pipe(mapTo(null));
  } 

}
